module.exports = __webpack_public_path__ + "static/media/cup.2749ae39.svg";